export default __webpack_public_path__ + "static/media/WHITEPAPER.810e19c9.pdf";